import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { EncriptDecriptService } from '../services/encriptdecript';
@Injectable()
export class IslogedInService implements CanActivate {

  constructor(private router:Router,private encriptDecriptService:EncriptDecriptService) {
  }

  canActivate(){
    var login=localStorage.getItem('isLogin');
    if (login=='false'|| login==undefined) {
      return true;
    } else {
      const url = this.encriptDecriptService.getLocalStorage('dashboardURL');
      if(login=='true'&&url !=undefined && url!=null){
        this.router.navigate([url]);
      }
      else{
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(['/login']);

      }

      return false;
    }
  }

}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/services/isloged-in.service.ts